import * as React from 'react';
import { compose, withProps } from 'recompose';
import { skin, OemProps } from 'ui/styles/skin';
import { CompoundMarkersMap, Marker, MarkerType, markerTypes } from 'types';

export type AllMarkerProps = {
    compoundMarkers: CompoundMarkersMap;
    segmentWidth: number;
    segmentHeight: number;
    segmentMargin: number;
    i: number;
    onClick: (marker: Marker) => void;
    onMouseOver: (e: React.MouseEvent<SVGElement>, marker: Marker) => void;
    onMouseOut: (e: React.MouseEvent<SVGElement>, marker: Marker) => void;
};
export type MarkerProps = AllMarkerProps & {
    markerType: MarkerType;
};

export const Markers = ({
    markerType,
    compoundMarkers,
    segmentWidth,
    segmentHeight,
    segmentMargin,
    i,
    onClick,
    onMouseOver,
    onMouseOut,
    styles,
}: MarkerProps & RecomposeProps) =>
    <g>
        { compoundMarkers[markerType] && compoundMarkers[markerType][i].map(({ position, markers }, j) =>
            <g
                key={ `${j}of${compoundMarkers.length}` }
                transform={ `translate(${position - (i * segmentWidth)}, ${i * (segmentHeight + segmentMargin)})` }
            >
                { /* red/white/black "circle" (using a rounded rect, which elongates with bigger text) */ }
                <rect
                    x={ markers.length > 9 ? -9 : markers.length > 1 ? -7 : -5 }
                    y={                           markers.length > 1 ? -7 : -5 }
                    width={ markers.length > 9 ? 18 : markers.length > 1 ? 14 : 10 }
                    height={                          markers.length > 1 ? 14 : 10 }
                    ry={ markers.length > 1 ? 7 : 5 }
                    rx={ markers.length > 1 ? 7 : 5 }
                    style={ styles.markerBody[markerType] }
                    onClick={ () => onClick(markers[0]) }
                    onMouseMove={ e => onMouseOver(e, markers[0]) /* Not a typo... we're reusing onMouseOver */ }
                    onMouseOver={ e => onMouseOver(e, markers[0]) }
                    onMouseOut={ e => onMouseOut(e, markers[0]) }
                />
                { markers.length > 1 &&
                    <g>
                        { /* black outline of text to increase contrast */ }
                        <text
                            x="0"
                            y="3"
                            textAnchor="middle"
                            fontSize="9px"
                            style={ styles.markerTextOutline }
                        >
                            { markers.length }
                        </text>
                        { /* white text */ }
                        <text
                            x="0"
                            y="3"
                            textAnchor="middle"
                            fontSize="9px"
                            style={ styles.markerText }
                        >
                            { markers.length }
                        </text>
                    </g>
                }
            </g>
        ) }
    </g>
;

type RecomposeProps = {
    styles: { [name: string]: React.CSSProperties };
};

export const RawAllMarkers = (props: AllMarkerProps & RecomposeProps) =>
    <g>
        { markerTypes.map(markerType =>
            <Markers
                key={ markerType }
                markerType={ markerType }
                { ...props }
            />
        ) }
    </g>
;

export const AllMarkers = compose<AllMarkerProps & RecomposeProps, AllMarkerProps>(
    skin,
    withProps(({ styles }: OemProps) => ({
        styles: {
            markerBody: markerTypes.reduce((s, markerType) => ({
                ...s,
                [markerType]: {
                    stroke: '#000000',
                    strokeOpacity: .5,
                    strokeWidth: 1,
                    fill: styles.TimelineBar[markerType].fill,
                },
            }), {}),
            markerTextOutline: {
                fill: '#000000',
                stroke: '#000000',
                strokeWidth: 2,
                strokeOpacity: .5,
                pointerEvents: 'none',
            },
            markerText: {
                fill: '#FFFFFF',
                pointerEvents: 'none',
            },
        },
    })),
)(RawAllMarkers);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/timeline/Markers.tsx